<app-navbar [title]="pageTitle">
	<!-- <button class="btn btn-warning me-2" (click)="deleteAsk()">Usuń</button> -->
	<button class="btn btn-primary me-2" *ngIf="!lockEdit" (click)="submit()">Zapisz</button>
	<button class="btn btn-primary me-2" *ngIf="lockEdit" (click)="editToggle()">Edycja</button>
	<a class="btn btn-danger" routerLink="../"> <i class="fas fa-chevron-left"></i> Powrót </a>
</app-navbar>

<div id="loader" *ngIf="loader"><span class="spinner-border spinner-grow-lg"></span></div>

<div class="container">
	<form class="my-4" (submit)="submit()">
		<fieldset [disabled]="lockEdit">
			<h4>Podstawowe</h4>
			<div class="mb-3 required">
				<label class="form-label" for="type">Rodzaj</label>
				<select
					data-bs-live-search="true"
					class="form-select"
					id="type"
					[(ngModel)]="lead.type"
					name="type"
					required
				>
					<option value="" hidden disabled selected></option>
					<option value="1">Indywidualny</option>
					<option value="2">Grupowy</option>
				</select>
			</div>
			<div class="mb-3 required">
				<label class="form-label" for="source">Źródło</label>
				<select
					data-bs-live-search="true"
					class="form-select"
					id="source"
					[(ngModel)]="lead.source"
					name="source"
					required
				>
					<option value="" hidden disabled selected></option>
					<option value="{{ item.id }}" *ngFor="let item of leadSources">{{ item.name }}</option>
				</select>
			</div>

			<h4>Dane osobiste</h4>
			<div class="mb-3">
				<label class="form-label" for="firstName">Imię</label>
				<input class="form-control" name="firstName" [(ngModel)]="lead.firstName" id="firstName" />
			</div>
			<div class="mb-3">
				<label class="form-label" for="lastName">Nazwisko</label>
				<input class="form-control" name="lastName" [(ngModel)]="lead.lastName" id="lastName" />
			</div>
			<div class="mb-3">
				<label class="form-label" for="gender">Płeć</label>
				<select
					data-bs-live-search="true"
					class="form-select"
					id="gender"
					[(ngModel)]="lead.gender"
					name="gender"
				>
					<option value="" hidden disabled selected></option>
					<option value="{{ item.code }}" *ngFor="let item of this.gender">{{ item.polish }}</option>
				</select>
			</div>
			<div class="mb-3">
				<label class="form-label" for="pesel">PESEL</label>
				<input class="form-control" name="pesel" [(ngModel)]="lead.pesel" id="pesel" />
			</div>

			<h4>Dane kontaktowe</h4>
			<div class="mb-3">
				<label class="form-label" for="email_1">Adres e-mail 1</label>
				<input class="form-control" name="email_1" [(ngModel)]="lead.email1" type="email" id="email_1" />
			</div>
			<div class="mb-3">
				<label class="form-label" for="email_2">Adres e-mail 2</label>
				<input class="form-control" name="email_2" [(ngModel)]="lead.email2" type="email" id="email_2" />
			</div>
			<div class="mb-3">
				<label class="form-label">Numer telefonu 1</label>
				<input type="tel" class="form-control" id="phone1" name="phone1" [(ngModel)]="lead.phone1" />
			</div>
			<div class="mb-3">
				<label class="form-label" for="tel2">Numer telefonu 2</label>
				<input type="tel" class="form-control" id="phone2" name="phone2" [(ngModel)]="lead.phone2" />
			</div>

			<h4>Dane adresowe</h4>
			<div class="mb-3">
				<label class="form-label" for="street">Adres</label>
				<input class="form-control" name="street" [(ngModel)]="lead.street" id="street" />
			</div>
			<div class="mb-3">
				<label class="form-label" for="city">Miasto</label>
				<input class="form-control" name="city" [(ngModel)]="lead.city" id="city" />
			</div>
			<div class="mb-3">
				<label class="form-label" for="zip_code">Kod pocztowy</label>
				<input class="form-control" name="zip_code" [(ngModel)]="lead.zip_code" id="zip_code" />
			</div>
			<div class="mb-3">
				<label class="form-label" for="country">Kraj</label>
				<input class="form-control" name="country" [(ngModel)]="lead.country" id="country" />
			</div>
		</fieldset>
	</form>
</div>
